import React from "react";
import { OrgDriverRates } from "./OrgDriverRates";
import { CityZipCodeConfig } from "./CityZipCodeConfig";

export const OrgDriverRatesContent = ({ data }) => {
  const renderZipCodeConfig = data && data.difference && data.difference[0] && !_.isEmpty(data.difference[0].city_zipcodes_config) ? true : false;
  const renderDriverRateSheet = () => {
    return <OrgDriverRates data={data} />;
  };

  const renderCityZipCodeConfig = () => {
    return <CityZipCodeConfig data={data} />;
  };
  return (
    <div>
      {renderDriverRateSheet()}
      {renderZipCodeConfig && renderCityZipCodeConfig()}
    </div>
  );
};
